import React from "react";
import { ResizableBox } from "react-resizable";
import ReactResizeDetector from "react-resize-detector";
import { EditorBlock, EditorState, Modifier } from "draft-js";

export default class EditorGridCell extends React.Component {
  _load = () => {
    this.heightAdjust = 24;
    this.widthAdjust = 26;
    this.blockData = this.props.block.getData().toJS();
    this.editorWidth = this.props.blockProps.editorWidth;
    this.columnWidth = this.props.blockProps.columnWidth;
    this.defaultHeight = this.props.blockProps.defaultHeight;
  };
  constructor(props) {
    super(props);
    this._load();

    this.state = {
      boxWidthInitial: this.blockData.width || this.columnWidth,
      boxHeightInitial: this.blockData.height || this.defaultHeight,
      cellHeight: this.blockData.height || this.defaultHeight,
    };
  }
  componentDidUpdate() {
    this._load();
  }
  componentDidMount() {
    this._load();
  }

  onResizeBox = (w, h) => {
    let data = this.props.block.getData().toJS();
    this.props.blockProps.onResize(this.props.block.getKey(), w, h);
  };
  onResizeContent = (w, h) => {
    let entitiesResult = this.entitiesInBlock();
    if (entitiesResult.anyResizing) return false;
    let data = this.props.block.getData().toJS();
    let heightAdjust = h > data.contentHeight ? h + this.heightAdjust : false;
    if (data.height >= heightAdjust) heightAdjust = false;

    this.props.blockProps.onContentResize(
      this.props.block.getKey(),
      w,
      h,
      heightAdjust
    );
  };

  entitiesInBlock = () => {
    let result = {
      anyResizing: false,
      anyInputs: false,
      anyImages: false,
      entities: {},
    };

    let block = this.props.block.toJS();
    let characterList = block.characterList;
    if (characterList) {
      characterList.forEach((character) => {
        if (character.entity) {
          let entity = this.props.contentState
            .getEntity(character.entity)
            .toJS();
          if (entity.data.isResizing) result.anyResizing = true;
          if (entity.type === "USER_INPUT") result.anyInputs = true;
          if (entity.type === "USER_IMAGE") result.anyImages = true;

          result.entities[character.entity] = entity;
        }
      });
    }
    return result;
  };

  render() {
    let data = this.props.block.getData().toJS();
    let contentHeight = data.contentHeight + this.heightAdjust;
    return (
      <>
        <ResizableBox
          key={contentHeight}
          width={data.width || this.state.boxWidthInitial}
          height={data.height || this.state.boxHeightInitial}
          minConstraints={[
            this.columnWidth,
            data.contentHeight && contentHeight > this.defaultHeight
              ? contentHeight
              : this.defaultHeight,
          ]}
          maxConstraints={[this.editorWidth, 1000]}
          draggableOpts={{ grid: [this.columnWidth, this.heightAdjust] }}
        >
          <ReactResizeDetector
            skipOnMount
            handleWidth
            handleHeight
            onResize={this.onResizeBox}
          />
          <div
            className={`editor-grid-cell ${
              data.borderLeft ? "cell-border-left" : ""
            }
          ${data.borderRight ? "cell-border-right" : ""} ${
              data.borderTop ? "cell-border-top" : ""
            }
          ${data.borderBottom ? "cell-border-bottom" : ""}`}
          >
            <div className="editor-grid-cell-cotainer">
              <ReactResizeDetector
                skipOnMount
                handleHeight
                onResize={this.onResizeContent}
              />
              <EditorBlock {...this.props} />
            </div>
          </div>
        </ResizableBox>
      </>
    );
  }
}
